import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'

export default function initStyle() {
  return [
    registerThemeSpec('cmp.tooltip', {
      textContent: {
        wordBreak: 'break-all',
        maxWidth: 320,
      },
      base: {
        borderRadius: 'control',
        fontSize: '14px',
        lineHeight: '22px',
      },
      stateless: {
        outline: {
          color: 'brand',
          bg: 'white',
        },
        fill: {
          bg: '#444549',
          color: 'white',
        },
        default: {
          bg: 'white',
          color: 'body',
        },
      },
    }),
    registerThemeSpec('cmp.iconTooltip', {
      wrapper: {
        '&[is-shown]': {
          svg: {
            fill: 'brand',
          },
        },
      },
      icon: {
        cursor: 'pointer',
        fill: 'mute',
        '&:hover, &[data-shown]': {
          fill: 'brand',
        },
      },
    }),
  ]
}
